module.exports = __webpack_public_path__ + "4f5a3bd9b9f102d17fb17e750e636298.png";